export const options = {
    MC_VERSION: 57,
    THREEDS_VERSION: '1.3.0',
};